import type { ISaveCarEvent, ISaveCarInput } from '../types/clickEvents';

const saveCar = (input: ISaveCarInput): Omit<ISaveCarEvent, 'event'> => ({
  stockNumber: input.vehicle.stockNumber,
  linkDetails: input.linkDetails,
});

export default saveCar;
